/* eslint-disable import/no-anonymous-default-export */

import { useContext, useCallback } from 'react';

import { RoleDocument } from 'commons/models/marketingDashboard';
import { formatListData, AjaxContext } from 'commons-ui';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getRolesData = useCallback(async ({ app, pageDetails }: { app: any; pageDetails: any }) => {
		const res = await postData({
			endpoint: '/marketing/dashboard/role/getRoles',
			body: { page: pageDetails },
			queryParams: {
				appName: app.appName
			}
		});
		const listData = formatListData(res?.data?.roles);
		return { rowCount: res?.data?.totalRoles, data: listData };
	}, []);

	const requestUpdateRole = useCallback((appName: string, data: RoleDocument) => {
		return postData({
			endpoint: '/marketing/dashboard/role/updateRole',
			body: data,
			queryParams: {
				appName
			}
		});
	}, []);

	const requestCreateRole = useCallback((appName: string, data: RoleDocument) => {
		return postData({
			endpoint: '/marketing/dashboard/role/createRole',
			body: data,
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		getRolesData,
		requestUpdateRole,
		requestCreateRole
	};
};

export default useService;
